(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["auren-premium-motion"] && !Shopify.designMode) return;
  try {
    (() => {
    const start = () => {
      const main = document.querySelector('#main');
      const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      if (!main || reduceMotion || !('IntersectionObserver' in window)) {
        return;
      }

      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (!entry.isIntersecting) {
              return;
            }

            entry.target.classList.add('is-in-view');
            observer.unobserve(entry.target);
          });
        },
        {
          rootMargin: '0px 0px -10% 0px',
          threshold: 0.12
        }
      );

      const prepare = (scope) => {
        let sections = Array.from(scope.children).filter((element) => {
          return element.matches('.shopify-section, [id^="shopify-section-"], section');
        });

        if (sections.length === 0) {
          sections = Array.from(scope.querySelectorAll('.shopify-section')).filter((element) => {
            return !element.parentElement.closest('.shopify-section');
          });
        }

        const isHomePage = window.location.pathname === '/';
        const copySelector = [
          '.slideshow__text-wrapper',
          '.slideshow__text',
          '.banner__box',
          '.image-with-text__content',
          '.rich-text__blocks',
          '.section-header',
          '.section__header',
          '.title-wrapper-with-link',
          '.newsletter__wrapper',
          '.collection-hero__text-wrapper',
          '.product__info-wrapper',
          '.content-over-media > .prose',
          '.prose',
          '[class*="content-box"]',
          '[class*="text-box"]'
        ].join(',');

        sections.forEach((section, index) => {
          if (section.dataset.aurenMotionPrepared === 'true') {
            return;
          }

          section.dataset.aurenMotionPrepared = 'true';

          if (isHomePage && index === 1) {
            section.dataset.aurenMotionExcluded = 'true';
            return;
          }

          section.dataset.aurenMotionDirection = index % 3 === 1 ? 'left' : index % 3 === 2 ? 'right' : 'up';
          section.style.setProperty('--auren-motion-order', String(index % 4));
          section.classList.add('auren-motion-item');

          const media = section.querySelector('picture, video, img');
          if (media) {
            media.classList.add('auren-motion-media');
          }

          const copyCandidates = Array.from(section.querySelectorAll(copySelector));
          const copyTargets = copyCandidates.filter((target) => {
            return !copyCandidates.some((candidate) => {
              return candidate !== target && candidate.contains(target);
            });
          });

          copyTargets.slice(0, 8).forEach((target, copyIndex) => {
            target.classList.add('auren-motion-copy');
            target.dataset.aurenCopyDirection = copyIndex % 2 === 0 ? 'left' : 'right';
            target.style.setProperty('--auren-copy-order', String(copyIndex));
          });

          observer.observe(section);
        });
      };

      prepare(main);
      document.documentElement.classList.add('auren-motion-ready');

      document.addEventListener('shopify:section:load', (event) => {
        const section = event.target;
        section.dataset.aurenMotionPrepared = 'false';
        prepare(section.parentElement || main);
      });
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', start, { once: true });
    } else {
      start();
    }
  })();
  } catch(e) { console.error(e); }
})();

})();
